module.exports = __webpack_public_path__ + "img/img3.1a0494da.png";